import { defineStore } from 'pinia'
import type { DeliveryFormOption } from '@/models/checkout-delivery-model-v2'

export const useDeliveryStore = defineStore('delivery', () => {
  // TODO: Remove composable from store and use it directly
  const {
    deliveryData,
    setDeliveryAddress,
    setDeliveryType,
    setDeliveryPeriod,
    isHomeDeliveryPossible,
    isExpressDeliveryPossible,
    homeDeliveryLimit,
    expressDeliveryLimit,
    isHomeDeliveryLimitByZipCodes,
    isExpressDeliveryLimitByZipCodes,
    isDeliveryByAgreementAllowed,
    isHomeDeliveryAllowed,
    isExpressDeliveryAllowed,
    hasOnlyOneOption,
    confirmDeliveryType,
    confirmDeliveryAddress,
    deliveryOptions,
    hasDeliveryOptions,
    isLoading,
    reset,
  } = useDelivery()

  const selectedForm = ref<'delivery' | 'pickup'>()
  const setSelectedForm = (form: 'delivery' | 'pickup') => set(selectedForm, form)

  // Used for remembering which delivery type was selected before switching to pickup
  // e.g. Scenario: Standard and express delivery are available. User has selected express delivery and then switched to pickup. If user switches back to delivery, the previous selected delivery type should be express delivery and this is where this variable comes in.
  const previousDeliveryType = ref<DeliveryFormOption>()
  const setPreviousDeliveryType = (value: DeliveryFormOption) => set(previousDeliveryType, value)

  return {
    deliveryData,
    deliveryOptions,
    setDeliveryAddress,
    setDeliveryType,
    setDeliveryPeriod,
    isDeliveryByAgreementAllowed,
    isHomeDeliveryAllowed,
    isExpressDeliveryAllowed,
    hasOnlyOneOption,
    hasDeliveryOptions,
    isHomeDeliveryPossible,
    isExpressDeliveryPossible,
    homeDeliveryLimit,
    expressDeliveryLimit,
    isHomeDeliveryLimitByZipCodes,
    isExpressDeliveryLimitByZipCodes,
    isLoading,
    reset,
    previousDeliveryType,
    setPreviousDeliveryType,
    confirmDeliveryAddress,
    confirmDeliveryType,
    selectedForm,
    setSelectedForm,
  }
})
